export const skillsNames = ['HTML', 'CSS', 'Javascript', 'Figma', 'Sass', 'Bootstrap', 'React', 'Redux', 'GIT', 'Firebase', 'NodeJS', 'ExpressJS', 'MongoDB', 'Socket.io', ''];
export const skillsLogos = ['fa-html5', 'fa-css3-alt', 'fa-js-square', 'fa-figma', 'fa-sass', 'fa-bootstrap', 'fa-react', 'redux.png', 'fa-git-alt', 'firebase.png', 'fa-node-js', 'express.png', 'mongodb.png', 'socket.png', ''];

export const imagesProyects = [ 
    {
        id: "1",
        logo: 'mundoviole.png',
        img: 'mundo-viole.png',
        title: 'El Mundo de Viole',
        descriptionSpanish: 'Sitio web creado para una niña donde se muestran sus cuentos y dibujos, con un diseño intuitivo para que la administradora gestione estos.',
        descriptionEnglish: 'Website created for a little girl where her stories and drawings are shown, with an intuitive design for the administrator to manage them.',
        frontendTech: [ 'fa-html5', 'fa-sass', 'fa-react', 'redux.png'],
        backendTech: [ 'fa-node-js', 'express.png', 'mongodb.png' ],
        frontendGit: 'https://github.com/ariachuqui/el-mundo-de-viole',
        BackendGit: 'https://github.com/ariachuqui/el-mundo-de-viole-backend',
        liveLink: 'https://mundo-viole.netlify.app/'
    },
    {
        id: "2",
        logo: 'portfolio.png',
        img: 'portfolio.png',
        title: 'Portfolio',
        descriptionSpanish: 'Portfolio personal para demostrar mis habilidades y experiencias. Las animaciones en los titulos y el efecto 3D en “Skills” son creados por mí.',
        descriptionEnglish: 'Personal portfolio to demonstrate my skills and experiences. The animations in the titles and the 3D effect in "Skills" are created by me.',
        frontendTech: [ 'fa-html5', 'fa-sass', 'fa-react'],
        backendTech: null,
        frontendGit: 'https://github.com/ariachuqui/portfolio',
        BackendGit: null,
        liveLink: 'https://portfolio-ariachuqui.netlify.app/'
    },
    {
        id: "3",
        logo: 'la-milonga.png',
        img: 'la-milonga.png',
        title: 'La Milonga Argentina',
        descriptionSpanish: 'Sitio web freelance para "La Milonga Argentina", creado en equipo. Diseñamos un blog con un sistema muy intuitivo en el que el cliente puede gestionar la sección de artículos y albums por su propia cuenta.',
        descriptionEnglish: 'Freelance website for “La Milonga Argentina”, developed as a team. We designed a blog with a very intuitive system in which the client can manage the articles and albums section on their own.',
        frontendTech: [ 'fa-html5', 'fa-sass', 'fa-react', 'redux.png'],
        backendTech: [ 'firebase.png' ],
        frontendGit: null,
        BackendGit: null,
        liveLink: 'https://www.lamilongaargentina.com.ar/'
    },
    {
        id: "4",
        logo: 'calendarapp.png',
        img: 'calendarapp.png',
        title: 'Calendar App',
        descriptionSpanish: 'Aplicación web con autenticación y registro de usuarios, donde podrás agendar eventos en un calendario general, ver los eventos creados por otros y los demás ver los tuyos.',
        descriptionEnglish: 'Web application with authentication and user registration, where you can schedule events in a general calendar, you can see the events created by others and others can see yours.',
        frontendTech: [ 'fa-html5', 'fa-sass', 'fa-react', 'redux.png'],
        backendTech: [ 'fa-node-js', 'express.png', 'mongodb.png' ],
        frontendGit: 'https://github.com/ariachuqui/calendar-app-frontend',
        BackendGit: 'https://github.com/ariachuqui/calendar-app-backend',
        liveLink: 'https://ariachuqui.github.io/calendar-app-frontend/'
    },
    {
        id: "5",
        logo: 'journal.png',
        img: 'journal.png',
        title: 'Journal App',
        descriptionSpanish: 'Aplicación web con autenticación y registro de usuarios, donde podrás crear notas y llevarlas a todos lados.',
        descriptionEnglish: 'Web application with authentication and user registration, where you can create notes and take them always with you.',
        frontendTech: [ 'fa-html5', 'fa-sass', 'fa-react', 'redux.png'],
        backendTech: [ 'firebase.png' ],
        frontendGit: 'https://github.com/ariachuqui/journal-app',
        BackendGit: null,
        liveLink: 'https://ariachuqui.github.io/journal-app/'
    },
    {
        id: "6",
        logo: 'energy.png',
        img: 'energy.png',
        title: 'Energy',
        descriptionSpanish: 'Sitio Web de clases deportivas online. Los fondos y las animaciones son creadas por mí, se pueden apreciar mis habilidades en el diseño y creatividad a la hora de crear un sitio web.',
        descriptionEnglish: 'Online sports classes website. The backgrounds and animations are created by me, you can see my skills in design and creativity when designing a website.',
        frontendTech: [ 'fa-html5', 'fa-css3-alt', 'fa-js-square' ],
        backendTech: null,
        frontendGit: 'https://github.com/ariachuqui/energy-frontend',
        BackendGit: null,
        liveLink: 'https://energy-codo-a-codo.netlify.app/'
    },
];
